import { render } from "./HeaderLogo.vue?vue&type=template&id=aa4b2dc0&scoped=true&ts=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts"

import "./HeaderLogo.vue?vue&type=style&index=0&id=aa4b2dc0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4b2dc0"]])

export default __exports__